"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = FileSpace;

var _FileSpace = require("@adobe/react-spectrum-workflow/dist/FileSpace");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function FileSpace(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_FileSpace.A4uFileSpace, null));
}